<template>
  <div>
    <div class="flex items-center mb-2 space-x-4">
      <!-- Select Component -->
      <div class="flex flex-col space-x-2 items-left -mt-7">
        <label
          for="mobileSelect"
          class="ml-2 text-sm font-medium text-gray-700 "
          >Select Mobile to WhatsApp invoice
        </label>
        <select
          id="mobileSelect"
          v-model="selectedMobile"
          class="px-4 py-2 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="(item, index) in userMobiles"
            :value="item.value"
            :label="item.label + ' : ' + item.value"
            :key="index"
            >{{ item }}</option
          >
          <option value="">Enter Manually</option>
        </select>
      </div>

      <!-- Input Field -->
      <input
        v-model="selectedMobile"
        type="text"
        placeholder="Or enter phone here"
        class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <!-- Button -->
      <button
        @click="handleSendWhatsappVendorInvoice()"
        class="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <div class="flex">
          <span>
            Send to Whatsapp
          </span>
          <span v-if="isWhatsappLoader" class="ml-2 no-rows">
            <i class="fas fa-spinner fa-spin" />
          </span>
        </div>
      </button>
    </div>

    <div class="p-3 bg-gray-100">
      <div class="max-w-4xl p-4 mx-auto bg-white rounded-lg shadow-md">
        <div class="flex items-center justify-between pb-4 mb-4 border-b">
          <div>
            <h1 class="text-2xl font-bold text-gray-700">Invoice</h1>
            <p class="text-sm text-gray-500">
              Invoice #: {{ data.invoiceNumber }}
            </p>
            <p class="text-sm text-gray-500">
              Date: {{ data.invoiceDate | convertDate }}
            </p>
          </div>
          <div class="text-right">
            <img
              src="../../assets/images/rajdoot.png"
              class="ml-4 w-60"
              alt=""
            />
            <h2 class="text-lg text-gray-700 capitalize">
              <span class="font-bold">Rajdoot</span>:
              <span class="font-semibold"> {{ data.vendor.name }}</span>
            </h2>
            <p class="text-sm text-gray-500">
              Associated with Rajdoot Services
            </p>
            <p class="text-sm text-gray-500">Phone: {{ data.vendor.phone }}</p>
          </div>
        </div>

        <!-- Recipient Details -->
        <div class="mb-4">
          <h3 class="mb-2 text-lg font-semibold text-gray-700">Bill To:</h3>
          <p class="text-sm text-gray-500 capitalize">
            {{ data.customer.name }}
          </p>
          <!-- <p class="text-sm text-gray-500">{{ client.address }}</p> -->
          <p class="text-sm text-gray-500">Phone: {{ data.customer.phone }}</p>
        </div>

        <!-- Items Table -->
        <div class="mb-6">
          <table class="w-full text-sm border border-collapse border-gray-200">
            <thead>
              <tr class="bg-gray-100">
                <th class="px-4 py-2 text-left border border-gray-200">
                  Description
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Amount
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Quantity
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Disc.
                </th>

                <th class="px-4 py-2 text-right border border-gray-200">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.labors" :key="index">
                <td class="px-4 py-2 border border-gray-200">
                  {{ item.description }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.laborCost | currency }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.quantity }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.discount }}
                </td>

                <td class="px-4 py-2 text-right border border-gray-200">
                  {{
                    (item.laborCost * item.quantity - item.discount) | currency
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-between pt-4 border-t">
          <div>
            <h3 class="text-lg font-semibold text-gray-700">Notes</h3>
            <p class="text-sm text-gray-500">Thank you, visit again!</p>
          </div>
          <div class="text-right">
            <p class="text-sm text-gray-500">
              Total:
              <span class="font-semibold">{{ total | currency }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isWhatsappLoader: false,
      userMobiles: [],
      selectedMobile: null
    };
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    },
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  computed: {
    subtotal() {
      return this.items.reduce((sum, item) => sum + item.total, 0);
    },
    tax() {
      const tax = this.data.chalanItems.reduce((a, b) => a + b.taxAmount, 0);
      return tax;
    },
    total() {
      const total = this.data.labors.reduce(
        (a, b) => a + b.laborCost * b.quantity - b.discount,
        0
      );
      return total;
    },
    ...mapGetters({
      data: "vendor/getInvoiceData"
    })
  },
  mounted() {
    this.getUserMobiles();
  },
  methods: {
    fetchData() {
      this.getUserMobiles();
    },
    resetProperty() {
      this.userMobiles = null; // Reset the property
      this.selectedMobile = null;
    },
    getUserMobiles() {
      if (this.data && this.data.userId) {
        apiHelper
          .call(
            "get",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${this.data.userId}/mobiles`
          )
          .then(response => {
            this.userMobiles = response.data.mobiles;
          })
          .catch(() => {
            this.$notify({
              message: "Something went wrong",
              type: "danger",
              title: "Error"
            });
          });
      }
    },
    handleSendWhatsappVendorInvoice() {
      this.isWhatsappLoader = true;

      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/send/vendor-invoice/${this.data.serviceRequestId}`,
          { phone: this.selectedMobile }
        )
        .then(() => {
          this.isWhatsappLoader = false;
          this.userMobiles = [];
          this.selectedMobile = null;
          this.$notify({
            message: "Invoice sent to whtasapp",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    }
  }
};
</script>

<style scoped>
/* Add any additional custom styling here if needed */
</style>
